import { isNativeApp } from "./isNativeApp";

export function dispatchEventToNative(
  eventName: string,
  payload?: Record<string, unknown>,
) {
  console.log("dispatchEventToNative", eventName);

  // Electron
  window.dispatchEvent(new CustomEvent(eventName, { detail: payload }));

  // React Native
  if (isNativeApp) {
    window.ReactNativeWebView!.postMessage(
      JSON.stringify({
        type: eventName,
        payload,
      }),
    );
  }
}
